import { render } from "./ToggleWrap.vue?vue&type=template&id=a7d7b75a"
import script from "./ToggleWrap.vue?vue&type=script&lang=js"
export * from "./ToggleWrap.vue?vue&type=script&lang=js"
script.render = render

export default script